import './Chip.css';

export type ChipTone = 'default' | 'done';

export interface ChipProps {
  /** Texto já traduzido por quem usa (ver `StatusChip`). */
  label: string;
  /** `done`: texto e ponto `--color-fg-1` (AC-3.8-04). */
  tone?: ChipTone;
  /** Variante `plain`: sem ponto. */
  plain?: boolean;
  /** Sai da árvore de acessibilidade quando a linha inteira já tem `aria-label` próprio (ex.: `RaceRow`). */
  ariaHidden?: boolean;
  /** Classe do componente que compõe o chip (ex.: "status-chip"), somada a "chip". */
  class?: string;
  'data-testid'?: string;
  'data-state'?: string;
}

/** Rótulo compacto com ponto (§3.8 `Chip`). Não é interativo; o texto é real e o ponto é decorativo. */
export function Chip({
  label,
  tone = 'default',
  plain = false,
  ariaHidden = false,
  class: extra,
  'data-testid': testId = 'chip',
  'data-state': state,
}: ChipProps) {
  const classes = ['chip'];
  if (tone === 'done') classes.push('chip--done');
  if (plain) classes.push('chip--plain');
  if (extra) classes.push(extra);
  return (
    <span
      class={classes.join(' ')}
      data-testid={testId}
      data-state={state}
      aria-hidden={ariaHidden ? 'true' : undefined}
    >
      {plain ? null : <i class="chip__dot" aria-hidden="true" />}
      {label}
    </span>
  );
}
